import { Controller } from '@hotwired/stimulus';
import 'cally';

export default class extends Controller {
  static targets = ['dropdown', 'startInput', 'endInput', 'calendar'];

  connect() {
    // Close the dropdown when clicking outside
    document.addEventListener('click', this.handleOutsideClick);

    // Listen for date changes
    if (this.hasCalendarTarget) {
      this.calendarTarget.addEventListener(
        'change',
        this.handleDateChange.bind(this)
      );
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick);

    if (this.hasCalendarTarget) {
      this.calendarTarget.removeEventListener('change', this.handleDateChange);
    }
  }

  toggle(event) {
    event.stopPropagation();
    this.dropdownTarget.classList.toggle('hidden');
  }

  handleDateChange(event) {
    // Format is "YYYY-MM-DD/YYYY-MM-DD" for ranges
    const value = event.target.value;
    if (
      value.includes('/') &&
      this.hasStartInputTarget &&
      this.hasEndInputTarget
    ) {
      const [start, end] = value.split('/');
      this.startInputTarget.value = start;
      this.endInputTarget.value = end;
    }
  }

  handleOutsideClick = (event) => {
    if (
      !this.element.contains(event.target) &&
      !this.dropdownTarget.classList.contains('hidden')
    ) {
      this.dropdownTarget.classList.add('hidden');
    }
  };
}
